import { Box, Container, Grid2 as Grid, Link, Typography } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import React, { useEffect, useRef } from 'react';

const PrivacyPolicy = ({ router }) => {

    const scrollToTopRef = useRef(null);
    useEffect(() => {
        scrollToTopRef.current?.scrollIntoView({ behavior: "smooth" });
    }, []);


    const navigateTo = (path) => {
        router.navigate(path); // This navigates to the specific page
    };

    return (
        <div ref={scrollToTopRef}>
            <Container maxWidth="lg" sx={{ minHeight: "1000px" }}>
                {/* BREADCRUMPS WIDGET START */}
                <Grid container spacing={1} >
                    <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{ margin: '10px' }}>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link underline="hover" color="inherit" onClick={() => navigateTo('/')}>
                                Home
                            </Link>
                            <Typography sx={{ color: 'text.primary' }}>Prepayment Calculator</Typography>
                        </Breadcrumbs>
                    </Grid>
                </Grid>
                {/* BREADCRUMPS WIDGET ENDS */}

                <Box sx={{ padding: '20px' }}>
                    <Typography variant="h3" gutterBottom align="center">
                        Privacy Policy
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        Last updated: January 31, 2025
                    </Typography>

                    <Typography variant="body1" paragraph>
                        At FinCals.com, we take your privacy seriously. This Privacy Policy outlines how we handle your data and the tools used on our website.
                        We do not collect any personally identifiable information from users of our financial calculator.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        1. Information We Collect
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Our website does not collect any personal information such as names, email addresses, or payment details. The financial calculator is designed for users to input data anonymously.
                        No user data is stored or shared with third parties.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        2. Google Analytics
                    </Typography>
                    <Typography variant="body1" paragraph>
                        We use Google Analytics to track anonymous information about website usage. This data helps us analyze traffic and improve our content. Google Analytics collects data like:
                        <ul>
                            <li>Browser type</li>
                            <li>Device information</li>
                            <li>Pages viewed and time spent</li>
                        </ul>
                        Google Analytics does not collect personally identifiable information, and the data collected is used solely for analytical purposes.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        3. Google Ads
                    </Typography>
                    <Typography variant="body1" paragraph>
                        We have integrated Google Ads on our site to display advertisements. Google may collect data on user behavior for ad targeting purposes. The information collected is used to display relevant ads based on your browsing activity across websites.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        4. Cookies
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Our website may use cookies to improve your browsing experience. Cookies are small data files stored on your device. You can choose to disable cookies in your browser settings if you prefer.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        5. Third-Party Links
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Our website may contain links to third-party websites. Please be aware that we are not responsible for the content or privacy practices of these sites. We encourage you to review their privacy policies before sharing any personal information.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        6. Contact Us
                    </Typography>
                    <Typography variant="body1" paragraph>
                        If you have any questions or concerns about this Privacy Policy or our practices, please feel free to contact us at <Link href="mailto:nandilyfe@gmail.com">nandilyfe@gmail.com</Link>.
                    </Typography>
                </Box>
            </Container>
        </div>
    );
};

export default PrivacyPolicy;
